var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Box } from 'rebass';
export default function MessageBubble(_a) {
    var sx = _a.sx, _b = _a.reverseAlign, reverseAlign = _b === void 0 ? false : _b, _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, borderRadius = _a.borderRadius, props = __rest(_a, ["sx", "reverseAlign", "variant", "borderRadius"]);
    return (React.createElement(Box, __assign({ maxWidth: "408px", width: [0, 'stretch'], fontSize: 2, variant: "messageBubble." + variant, sx: __assign(__assign(__assign({ letterSpacing: 0, lineHeight: 'normal', overflowWrap: 'break-word' }, (sx ? sx : {})), (reverseAlign ? { alignSelf: "flex-end" } : { alignSelf: "flex-start" })), (borderRadius
            ? { borderRadius: borderRadius }
            : reverseAlign
                ? { borderRadius: "20px 4px 20px 20px" }
                : { borderRadius: "4px 20px 20px 20px" })) }, props)));
}
